import { Injectable } from '@angular/core';
import { GrowthBookService } from 'src/app/services/growthbook.service';
import { FeatureFlags } from './feature-flags';

@Injectable({ providedIn: 'root' })
export class FeatureFacade {
  constructor(private gb: GrowthBookService) {}

  isFooterEnabled(): boolean {
    return this.gb.isOn(FeatureFlags.FooterTermsPrivacy);
  }
}